<ng-container [appPreloader]="[endpoints.STRIPE_CHECKOUT_SESSION_POST,
                               endpoints.USER_CURRENT_GET,
                               endpoints.SERVICE_PRICES_GET,
                               endpoints.SUBSCRIPTION_LAST_GET,
                               endpoints.PRORATION_COST_POST,
                               endpoints.SUBSCRIPTION_ITEMS_PUT,
                               endpoints.PRORATION_COST_POST,
                               endpoints.SERVICE_SUBSCRIPTIONS_PUT,
                               endpoints.SERVICE_SUBSCRIPTIONS_POST]"
              [preloaderType]="preloaderTypes.OVERLAY">
</ng-container>

<div mat-dialog-title class="pb-15">
  <div class="dialog-caption">
    Your TaxTank subscription
    <i class="icon-info ic-text fs-extra-big ml-5"
       matTooltip="TaxTank subscriptions are now billed annually, with automatic discounts applied based on the number of Tanks you select. There are no lock-in contracts. Existing monthly plans only change when you upgrade or cancel."></i>
  </div>
  <div class="dialog-subtitle mt-5">
    Select tanks that match your needs. Pay only for what you need, no lock-in contracts and 100% tax deductible!
  </div>
  <button mat-dialog-close class="btn icon-close"></button>
</div>

<div mat-dialog-content [class.d-none]="isHidden">
  <div class="row gy-2">
    <div class="col-12 col-lg-5 mt-0">
      <!--      @todo:  TT-5555 taxtankit move product to separate component to remove fn calls-->
      @for (product of products; track product) {
        <div class="product"
             [class.active]="checkbox.checked"
             (click)="toggleProduct(product)">
          <div class="align-h-space-between text-subtitle">
            <div class="mt-5">
              <div class="align-v-center">
                <mat-checkbox appPreventDefault #checkbox [checked]="subscription.hasProduct(product)"></mat-checkbox>
                <div class="c-secondary ml-10">{{ product.title }}</div>
                <i class="icon-info ic-text ml-5" [matTooltip]="tooltips[product.id]"></i>
              </div>
            </div>
            <div class="c-secondary mt-5">
              <div class="d-flex">
                @if (subscription.promoCode || subscription.items.length > 1) {
                  <div class="c-text line-through mr-5">
                    {{ pricesByProduct.get(product.id).amount * (product.isProperties() ? propertiesQty : 1) / 12 | customCurrency }}
                  </div>
                }
                <div class="c-secondary d-inline">
                  {{ discountPricesByProduct.get(product.id) * (product.isProperties() ? propertiesQty : 1) / 12 | customCurrency }}
                </div>
                /<span class="text-description c-secondary">month</span>
              </div>
              <div class="text-cell c-text">
                Billed annually at
                {{ discountPricesByProduct.get(product.id) * (product.isProperties() ? propertiesQty : 1) | customCurrency }}
              </div>
            </div>
          </div>

          @switch (true) {
            @case (product | call : "isWorkTank") {
              <div class="align-h-right text-description">
                Essential features for individual taxpayers
              </div>
            }
            @case (product | call : "isProperties") {
              <div class="row">
                <div class="col-6">
                  <div class="text-description mb-5">Included property</div>
                  <div class="quantity-selector">
                    <!--            @TODO prime form control-->
                    <p-inputNumber [(ngModel)]="propertiesQty"
                                   [disabled]="!subscription.hasPropertyTank()"
                                   [showButtons]="true"
                                   (click)="$event.stopPropagation()"
                                   buttonLayout="horizontal"
                                   [min]="propertiesMinQty"
                                   [max]="propertiesMaxQty"
                                   incrementButtonIcon="fa fa-plus c-secondary"
                                   decrementButtonIcon="fa fa-minus c-secondary"
                                   (ngModelChange)="updatePropertiesQuantity()">
                    </p-inputNumber>
                  </div>
                </div>

                <div class="col-6 align-v-bottom align-h-right text-description">
                  {{ discountPricesByProduct.get(product.id) | customCurrency }}
                  /year for each <br> additional property
                </div>
              </div>
            }
            @case (product | call : "isHoldingsTank") {
              <div class="align-h-right text-description">
                Unlimited holdings and trades
              </div>
            }
            @case (product | call : "isSoleTank") {
              <div class="align-h-right text-description">
                Up to 6 businesses
              </div>
            }
            @case (product | call : "isMoneyTank") {
              <div class="align-h-right text-description">
                Set unlimited budgets & goals
              </div>
            }
          }
        </div>
      }

      @if (!subscription.id) {
        <!-- promo codes allowed only for new subscriptions -->
        <app-promo-code-form (changed)="setPrices()" [subscription]="subscription" [firstPayment]="firstPayment"></app-promo-code-form>
      }
    </div>

    <div class="col-12 col-lg-7">
      <div class="bg-light p-15 c-secondary">
        <div class="h6">
          @if (subscription.items.length) {
            @for (item of subscription.items; track item; let i = $index) {
              {{ products.findBy('id', item.price.product.id).title }}
              @if (i < subscription.items.length - 1) {
                <span> + </span>
              }
            }
          }

          @if (!subscription.items.length) {
            Please select products
          }
        </div>

        <div class="row gy-3 text-body">
          @for (feature of features; track feature) {
            <div class="col-12 col-md-6">
              <div class="align-v-center">
                <!-- @TODO Alex: bad performance -->
                @if (featuresJoin.includes(feature)) {
                  <i class="icon-check ic-success mr-10"></i>
                } @else {
                  <i class="icon-close ic-error mr-10"></i>
                }
                {{ feature }}
              </div>
            </div>
          }
        </div>
      </div>

      <div class="row g-2">
        <ng-container *ngTemplateOutlet="tankBadge; context: { count: 1, label: '2 TANKS', percent: '5%' }">
        </ng-container>

        <ng-container *ngTemplateOutlet="tankBadge; context: { count: 2, label: '3 TANKS', percent: '10%' }">
        </ng-container>

        <ng-container *ngTemplateOutlet="tankBadge; context: { count: 3, label: '4 TANKS', percent: '15%' }">
        </ng-container>

        <ng-container *ngTemplateOutlet="tankBadge; context: { count: 4, label: '5 TANKS', percent: '20%' }">
        </ng-container>
      </div>

      <div class="row mt-10 ph-10">
        <div class="col-12 about-profit-text rounded"
             [ngClass]='{"status-badge-approved": subscription.items.length > 1, "c-success": subscription.items.length === 1}'>
          @switch (subscription.items.length) {
            @case (0) {
              @if (subscription.promoCode) {
                You received {{ subscription.promoCode | call:'getLabel' }}! <br>
              }
              Select tanks to see available discounts
            }
            @case (1) {
              @if (subscription.promoCode) {
                You're saving {{ subscription.promoCode | call:'getLabel' }} <br>
              }
              Add 1 more tank to unlock 5% discount!
            }
            @default {
              You're saving {{ subscription.discountAmount | customCurrency }} over 12 months ({{ 5 * (subscription.items.length - 1) }}% off
              @if (subscription.promoCode) {
                + {{ subscription.promoCode | call:'getLabel' }} coupon
              }
              )
            }
          }
        </div>
      </div>
    </div>
  </div>
</div>

<div mat-dialog-actions class="d-block pt-0 pb-25">
  <div class="w-100 mb-10 align-h-center">
    <form id="agree-form" class="p-0 bg-white" [formGroup]="form" (ngSubmit)="onSubmit($event)">
      <mat-checkbox formControlName="checkbox" required>
          <span class="c-secondary fw-600">
            Subscriptions are non-refundable and, if cancelled, remain active until the end of the billing period.*
          </span>
      </mat-checkbox>
    </form>
  </div>
  <div class="row">
    <div class="col-auto align-v-center">
      <div class="fs-extra-big fw-bold c-secondary">
        Total: {{ subscription.price | customCurrency }} annually
        @if (subscription.promoCode || subscription.items.length > 1) {
          <span class="c-text">
            (
            <span class="line-through">{{ subscription.initialPrice / 12 | customCurrency }}</span>
            {{ subscription.price / 12 | customCurrency }} Monthly
            )
          </span>
        }
      </div>
    </div>

    <div class="col-12 col-sm">
      <div class="align-h-right">
        <button (click)="dialogRef.close()" class="btn basic compact mr-10">Cancel</button>

        <button [disabled]="!subscription.items.length"
                type="submit"
                form="agree-form"
                name="continue"
                class="btn primary m-0"
                id="upgrade-subscription-button"
                data-event="subscribe"
                data-platform="taxtank"
                data-purpose="subscription">
          Upgrade subscription
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #tankBadge let-count="count" let-label="label" let-percent="percent">
  <div class="col-3">
    <div class="w-100 p-10 rounded align-h-space-between align-v-center"
         [ngClass]="{
          'status-badge-approved': subscription.items.length > count,
          'status-badge-pending': subscription.items.length === count
          }">

      <div class="align-v-center c-deep-blue fw-500">
        @if (subscription.items.length < count) {
          <div class="marker-donut mr-10"></div>
        }
        @if (subscription.items.length === count) {
          <i class="icon icon-arrow-right ic-warning mr-10"></i>
        }
        @if (subscription.items.length > count) {
          <i class="icon icon-check ic-success mr-10"></i>
        }
        {{ label }}
      </div>

      <span class="c-success">{{ percent }}</span>
    </div>
  </div>
</ng-template>
